export default {"src":"/_next/static/media/delegate.12c5d3ef.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};